import React, { useState } from "react";
import { Share2, Check } from "lucide-react";

const WhatsAppIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.967-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.695.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

/**
 * Share button. Uses navigator.share() (mobile/Web Share API) when available,
 * otherwise falls back to wa.me deep link.
 */
export const ShareWhatsAppButton = ({
  variant = "tile",
  url,
  message = "Sto ascoltando MADRETERRA radio in diretta 🕊️ Unisciti a me:",
}) => {
  const [done, setDone] = useState(false);

  const handleShare = async () => {
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const text = `${message} ${shareUrl}`;

    // Use native share sheet when available (iOS/Android), so the user can pick
    // WhatsApp, Telegram, Messages, etc. Falls back to wa.me.
    if (
      typeof navigator !== "undefined" &&
      typeof navigator.share === "function"
    ) {
      try {
        await navigator.share({
          title: "MADRETERRA radio",
          text: message,
          url: shareUrl,
        });
        setDone(true);
        setTimeout(() => setDone(false), 2200);
        return;
      } catch (_e) {
        /* user cancelled or unsupported — fall through */
      }
    }

    const waUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(waUrl, "_blank", "noopener,noreferrer");
    setDone(true);
    setTimeout(() => setDone(false), 2200);
  };

  if (variant === "tile") {
    return (
      <button
        type="button"
        onClick={handleShare}
        data-testid="share-whatsapp-btn"
        className="mt-btn group flex items-center gap-4 rounded-xl border px-4 py-4 text-left w-full"
        style={{
          borderColor: "rgba(37,211,102,0.40)",
          background: "rgba(37,211,102,0.10)",
        }}
      >
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
          style={{
            background: "rgba(37,211,102,0.18)",
            color: "#3ee07e",
            border: "1px solid rgba(37,211,102,0.30)",
          }}
        >
          {done ? <Check size={18} strokeWidth={2.4} /> : <WhatsAppIcon size={18} />}
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="text-[10px] uppercase tracking-[0.28em]"
            style={{ color: "var(--mt-text-muted)" }}
          >
            Condividi
          </div>
          <div
            className="font-display text-base sm:text-lg leading-tight truncate"
            style={{ color: "var(--mt-cream)" }}
          >
            {done ? "Condiviso!" : "Invia su WhatsApp"}
          </div>
        </div>
        <Share2
          size={15}
          strokeWidth={2.2}
          className="opacity-50 group-hover:opacity-100 transition-opacity"
          style={{ color: "var(--mt-cream)" }}
        />
      </button>
    );
  }

  // Compact pill variant
  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid="share-whatsapp-pill"
      className="mt-btn inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs font-semibold"
      style={{
        background: "#25D366",
        color: "#0a2412",
      }}
    >
      {done ? <Check size={13} strokeWidth={2.6} /> : <WhatsAppIcon size={13} />}
      {done ? "Condiviso" : "Condividi"}
    </button>
  );
};

export default ShareWhatsAppButton;
